import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import './index.css';

import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LoaderMain from "./components/globalloaders/LoaderMain";
import { useLoading } from './components/globalloaders/LoadingContext';

// Guards
import MasterRouteGuard from "./guard/MasterRouteGuard";
import PublicRouteGuard from "./guard/PublicRouteGuard";

// Main Pages
import Login from "./pages/auth/Login";
import Admin from "./pages/admin/Admin";
import Rider from "./pages/rider/Rider";

const App = () => {

  const { isLoading } = useLoading();

  // Service-Worker for Auto-Update
  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
    let updateInterval;

    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // Check for a new version every 180 seconds
        updateInterval = setInterval(() => {
          registration.update();
        }, 180000);

        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.onstatechange = () => {
            if (
              installingWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              console.log("New version available. Reloading.");
              window.location.reload();
            }
          };
        };
      })
      .catch(() => {
        console.error("Service Worker registration failed");
      });
    return () => {
      if (updateInterval) {
        clearInterval(updateInterval);
      }
    };
  }, []);

  return (
    <>
      {isLoading && <LoaderMain />}

      <Routes>
        <Route path="/"
          element={
            <PublicRouteGuard>
              <Login />
            </PublicRouteGuard>
          }
        />

        <Route path="/admin/*"
          element={
            <MasterRouteGuard allowed={["admin"]}>
              <Admin />
            </MasterRouteGuard>
          }
        />

        <Route path="/rider/*"
          element={
            <MasterRouteGuard allowed={["rider"]}>
              <Rider />
            </MasterRouteGuard>
          }
        />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={2800}
        limit={2}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover
        theme="light"
        transition={Slide}
      />
    </>
  );
};

export default App;